export default "__VITE_ASSET__DHWWJthy__"